// extracted by mini-css-extract-plugin
export var required = "_h2-0";